export type TranslationTextItem = { [key: string]: { en?: string; nb?: string; sv?: string } };

export type TranslationTextMap = {
  [key: string]: TranslationTextItem;
};
